export default function LogoSection({
  logoSrc = "/img/logo2.png",
  altText = "OSHIMED Logo",
  title = "",
  tagline = "",
  titleColor = "text-indigo-500",
}) {
  return (
    <>
      {/* Desktop logo - hidden on small screens, visible on medium and up */}
      <div className="hidden md:flex md:w-1/3 flex-col items-center justify-start pt-8">
        <div className="w-64 flex flex-col items-center">
          <div className="relative w-full h-full mb-6">
            <img src={logoSrc || "/placeholder.svg"} alt={altText} className="mx-auto" />
          </div>
          <div className="text-center">
            <h3 className={`${titleColor} text-4xl font-extrabold tracking-wide rounded-lg`}>{title}</h3>
            <p className={`${titleColor} text-lg mt-2`}>{tagline}</p>
          </div>
        </div>
      </div>

      {/* Mobile logo - shown only on small screens */}
      <div className="flex md:hidden w-full flex-col items-center justify-center mt-8 mb-4">
        <div className="w-32 flex flex-col items-center">
          <div className="relative w-full h-full mb-4">
            <img src={logoSrc || "/placeholder.svg"} alt={altText} className="mx-auto" />
          </div>
          <div className="text-center">
            <h3 className={`${titleColor} text-2xl font-extrabold tracking-wide rounded-lg`}>{title}</h3>
            <p className={`${titleColor} text-sm mt-1`}>{tagline}</p>
          </div>
        </div>
      </div>
    </>
  )
}
